import React from 'react'
import { View, Text, StyleSheet } from '@react-pdf/renderer'
import { OpForPDFType } from '../Modals/ViewPCP/GeneratePDFModal'

const styles = StyleSheet.create({
  tableHeader: {
    flexDirection: 'row',
    backgroundColor: '#f0f0f0',
    borderBottomWidth: 1,
    borderBottomColor: '#ccc',
    marginBottom: 5,
  },
  tableHeaderCell: {
    fontSize: 8,
    fontWeight: 'bold',
    lineHeight: 1.3,
    textAlign: 'center',
    padding: 4,
    flex: 1,
    borderRightWidth: 1,
    borderRightColor: '#ccc',
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#eee',
    minHeight: 18,
  },
  tableCell: {
    fontSize: 8,
    lineHeight: 1.3,
    textAlign: 'left',
    padding: 4,
    flex: 1,
    borderRightWidth: 1,
    borderRightColor: '#eee',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    wordWrap: 'break-word',
    overflow: 'hidden',
  }
})


interface TableDataProps {
  tableHeaders: string[]
  tableData: Array<Array<{value: string, type?: 'string' | 'image'}>>
  columnFlex?: number[]
}

const TableOfPDF: React.FC<TableDataProps> = ({ tableData, tableHeaders, columnFlex }) => {
  const flexFor = (index: number) => (columnFlex && columnFlex[index] != null ? columnFlex[index] : 1)
  return (
    <>
      <View style={styles.tableHeader}>
        {tableHeaders.map((header, index) => 
          <Text style={[styles.tableHeaderCell, { flex: flexFor(index) }]} key={index}>{header}</Text>
        )}
      </View>
        {tableData.map((row, index) => 
          <View key={index} style={styles.tableRow} wrap={false}>
            {row.map((cell, cellIndex) => 
              <Text style={[styles.tableCell, { flex: flexFor(cellIndex) }]} key={cellIndex}>{cell.value}</Text>
            )}
          </View>
        )}
    </>
  )
}

export default TableOfPDF